import React from "react";
import ReactPaginate from "react-paginate";
import {
  FirstPage,
  LastPage,
  ChevronLeft,
  ChevronRight,
} from "@mui/icons-material";

export default function Paginator(props) {
  const { totalItemsCount, itemsCountPerPage, activePage, onChange } = props;

  // Handle invalid or missing values
  if (
    !totalItemsCount ||
    !itemsCountPerPage ||
    totalItemsCount <= 0 ||
    itemsCountPerPage <= 0
  ) {
    return null;
  }

  const pageCount = Math.ceil(totalItemsCount / itemsCountPerPage);
  if (pageCount <= 1) return null;

  const handlePageChange = (selected) => onChange(selected + 1);

  const pageRangeDisplayed = 5;
  const marginPagesDisplayed = 2;

  const onBreakClick = (e) => {
    e.preventDefault();

    const insideMiddleWindow =
      activePage > marginPagesDisplayed + pageRangeDisplayed;
    let target;

    if (insideMiddleWindow) {
      target = Math.max(1, activePage - pageRangeDisplayed);
    } else {
      target = Math.min(pageCount, activePage + pageRangeDisplayed);
    }

    onChange(target);
  };

  return (
    <div className="d-flex justify-content-center align-items-center my-2">
      {/* First Page Button */}
      <button
        className="btn btn-link page-first-btn p-0"
        disabled={activePage === 1}
        onClick={() => onChange(1)}
      >
        <FirstPage className="pagination-icons" />
      </button>

      {/* Main Pagination */}
      <ReactPaginate
        breakLabel={
          <button
            onClick={onBreakClick}
            style={{
              cursor: "pointer",
              border: "none",
            }}
          >
            ...
          </button>
        }
        nextLabel={<ChevronRight className="pagination-icons" />}
        previousLabel={<ChevronLeft className="pagination-icons" />}
        pageCount={pageCount}
        forcePage={activePage - 1}
        onPageChange={(data) => handlePageChange(data.selected)}
        containerClassName="pagination mb-0"
        pageClassName="page-item"
        pageLinkClassName="page-link"
        activeClassName="active"
        previousClassName="page-item"
        nextClassName="page-item"
        previousLinkClassName="page-link"
        nextLinkClassName="page-link"
        pageRangeDisplayed={pageRangeDisplayed}
        marginPagesDisplayed={marginPagesDisplayed}
      />

      {/* Last Page Button */}
      <button
        className="btn btn-link page-last-btn p-0"
        disabled={activePage === pageCount}
        onClick={() => onChange(pageCount)}
      >
        <LastPage className="pagination-icons" />
      </button>
    </div>
  );
}
